module.exports = __webpack_public_path__ + "orkney-islands.svg?dcb2a0f8fb3f4214c9c8c74e85692628";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/orkney-islands.svg
// module id = 257
// module chunks = 10